import { render } from "./CoverTextInput.vue?vue&type=template&id=6d7e2f1a"
import script from "./CoverTextInput.vue?vue&type=script&lang=js"
export * from "./CoverTextInput.vue?vue&type=script&lang=js"

import "./CoverTextInput.vue?vue&type=style&index=0&id=6d7e2f1a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__